import { Checkbox, Divider, Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import logo from 'assets/images/logo.jpg';
import styled from 'styled-components';
import TextHeader from 'components/CustomText/TextHeader';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomTextField from 'components/Input/CustomTextField';
import useCurrentApplication from 'hooks/useCurrentApplication';
import { UPDATE_FORM_VALIDITY } from 'store/key';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    paperMargin: {
        margin: 10,
    },
    gridPadding: {
        padding: 10,
    },
    loginLogo: {
        objectFit: 'contain',
        height: 120,
    },
}));

const SLayout = styled.div`
    font-size: 13px;
`;

const SAppNumberLayout = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 16px;
`;

function InstructionFormLayout({ type, defaultData, onFormUpdate = () => null, formId, disableOnPermission = false }) {
    const classes = useStyles();
    const [postData, setPostData] = useState({});
    const dispatch = useDispatch();

    const currentApplication = useCurrentApplication({ id: formId });

    useEffect(() => {
        dispatch({
            type: UPDATE_FORM_VALIDITY,
            payload: {
                type: 'study',
                applicationFormId: formId,
                formKey: 'instruction',
                isValid: getData('acknowledgment'),
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultData]);

    const getData = (key) => {
        return postData[key] ?? defaultData[key];
    };

    const onFieldChange = (e) => {
        const { checked } = e.target;

        setPostData((prevData) => {
            return {
                ...prevData,
                acknowledgment: checked,
            };
        });

        onFormUpdate('acknowledgment', checked);

        dispatch({
            type: UPDATE_FORM_VALIDITY,
            payload: {
                type: 'study',
                applicationFormId: formId,
                formKey: 'instruction',
                isValid: checked,
            },
        });
    };

    const Instructions = [
        'Central Institutional Review Board / Cluster Research Ethics Committee/Institutional Review Board (“CIRB/CREC/IRB”) is dedicated to oversee clinical studies conducted by Hospital Authority ("HA")/University personnel in the Cluster with the aim of protecting the rights, safety and well-being of the human subjects recruited for the studies. The Applicant / Principal Investigator must be designated to take the final responsibility for protecting the rights, safety and well-being of subjects recruited from the Cluster.',
        'Please submit the application via online system, enter all information required and upload relevant application dossier files to the required fields.',
        // 'This form is only fully functional with Microsoft Silverlight. This form can only support retrieval of the following attachments - [1] Common Image files, [2] HTML and XML files, [3] Media files, [4] Microsoft Office files (except .mdb files), [5] PDF files, [6] Text files.',
        // 'This Form does not support certain symbol and text format adjustment. For example, enter text “beta” instead of symbol “β” or copy and paste “β” from another source, and use symbol ^ to indicate “power”, e.g. 4x10^3 instead of 4x10³.',
        'Research protocol, investigator brochures, consent forms, and written materials to subjects must be uniquely identified, for example, by Application Reference Number, document numbers, version numbers and dates.',
        `For information on research ethics and methodology, please visit HA Research Ethics Intranet Website (<a href="http://cetm.home/ces/re/Home.aspx" target="_blank">http://cetm.home/ces/re/Home.aspx</a>)`,
        'The handling and storage for data containing personal identity must comply with HA Clinical Data Policy Manual and other prevailing HA policies and university policies if applicable.',
        `Selected information will be passed to the HA's and University's Central Register of Clinical Research for the purpose of central record and risk management.`,
        'Information will be passed to corresponding Central IRB / CREC/IRB for the purpose of research ethics review. ',
    ];

    const Reminder = [
        {
            title: 'Hospital Authority as a Research Institution',
            content:
                'The HA is a body corporate established under the Hospital Authority Ordinance (Chapter 113 of the laws of Hong Kong). In addition to the primary responsibilities of establishing, managing, controlling and developing the public hospital system in Hong Kong and advising the Hong Kong government on healthcare policies and strategies, the HA also has the responsibility to promote, assist and take part in research relating to hospital services (Chapter 113, Section 4(f) (ii) of the laws of Hong Kong).',
        },
        {
            title: 'Local Regulation on Clinical Studies of Pharmaceutical Products',
            content:
                'Clinical studies of pharmaceutical products are regulated in Hong Kong under the Pharmacy and Poisons Regulations (Chapter 138A Regulation 36B of the laws of Hong Kong). For the purpose of regulatory compliance, a Certificate for Clinical Trial ("CTC") shall be obtained before initiation of clinical study of pharmaceutical product. ',
        },
        {
            title: 'Acceptance of Sponsorship for Clinical Research',
            content:
                'The HA is a statutory independent organization funded by public revenue and has a set of policies and guidelines on acceptance of sponsorship in order to manage and avoid possible conflict of interest situations. Please take note of the “Key Points to Note for Acceptance of Sponsorship” if sponsorship to the clinical research is expected. ',
        },
    ];

    return (
        <SLayout style={{ padding: 10, position: 'relative' }}>
            {currentApplication?.appNo && (
                <SAppNumberLayout>CRER Application No: {currentApplication.appNo}</SAppNumberLayout>
            )}
            <Paper>
                <Grid>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <img className={classes.loginLogo} src={logo} alt="logo" />
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <TextHeader>Hospital Authority</TextHeader>
                        <TextSubHeader style={{ marginTop: 10 }}>
                            Clinical Research Ethics Review Application Form
                        </TextSubHeader>
                    </div>
                    <Divider style={{ width: '100%', margin: '20px 0' }} />
                    <TextHeader style={{ margin: 'auto', textAlign: 'center', width: 400 }}>
                        <CustomTextField
                            disabled
                            value={currentApplication?.refNo}
                            label={'IRB/ REC Reference No. (For Office Use)'}
                            maxLength={255}
                        />
                    </TextHeader>

                    <div style={{ textAlign: 'center', marginTop: 20 }}>
                        <TextHeader>Instructions to applicant</TextHeader>
                    </div>
                    {Instructions.map((item, idex) => {
                        return (
                            <div
                                key={idex}
                                style={{
                                    display: 'flex',
                                    alignItems: 'space-between',
                                    marginTop: 15,
                                    padding: '0 10px',
                                }}
                            >
                                <div key={idex} style={{ width: 25, flexShrink: 0 }}>
                                    {idex + 1}.
                                </div>
                                <div
                                    key={item}
                                    style={{ flex: 1, textAlign: 'justify' }}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                ></div>
                            </div>
                        );
                    })}

                    <div style={{ textAlign: 'center', marginTop: 20 }}>
                        <TextHeader>Reminder</TextHeader>
                    </div>
                    {Reminder.map((item, idex) => {
                        return (
                            <div
                                key={idex}
                                style={{
                                    display: 'flex',
                                    alignItems: 'space-between',
                                    marginTop: 20,
                                    padding: '0 10px',
                                }}
                            >
                                <div style={{ width: 25, lineHeight: 1.6, flexShrink: 0 }}>{idex + 1}.</div>
                                <div style={{ flex: 1, lineHeight: 1.6 }}>
                                    <TextSubHeader>{item.title}</TextSubHeader>
                                    <div style={{ textAlign: 'justify' }}>{item.content}</div>
                                </div>
                            </div>
                        );
                    })}
                    <div style={{ paddingLeft: 35, marginTop: 10 }}>
                        <a target="_blank" href="http://www.ha.org.hk/haho/ho/hrd/key_letter_Eng1.pdf" rel="noreferrer">
                            http://www.ha.org.hk/haho/ho/hrd/key_letter_Eng1.pdf
                        </a>
                    </div>

                    <div style={{ padding: '10px 0 10px 35px' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox
                                disabled={disableOnPermission}
                                color="primary"
                                style={{ padding: 0 }}
                                checked={getData('acknowledgment') ?? false}
                                onChange={onFieldChange}
                            />
                            <div style={{ paddingLeft: 10 }}>Acknowledgement of instructions and reminder</div>
                        </div>
                    </div>
                </Grid>
            </Paper>
        </SLayout>
    );
}

export default InstructionFormLayout;
